import { API_ENDPOINTS } from "../../config/api.js";
import { makeApiRequest } from "../apiClient.js";

export const authorizationService = {
    saveRoleScreenMapping: async (data) => {
        try {
            const response = await makeApiRequest({
                endpoint: API_ENDPOINTS.SAVE_ROLE_SCREEN_MAPPING,
                method: "POST",
                data,
                accessToken: localStorage.getItem("accessToken"),
            });
            return response;
        } catch (error) {
            console.error("Error creating screen:", error);
            throw error;
        }
    },
    getAll: async ({ groupId }) => {
        try {
            const response = await makeApiRequest({
                endpoint: API_ENDPOINTS.GET_ROLE_SCREEN_MAPPING,
                method: "POST",
                data: { groupId },
                accessToken: localStorage.getItem("accessToken"),
            });
            return response;
        } catch (error) {
            console.error("Error fetching screens:", error);
            throw error;
        }
    }
};  